// @flow
import React from 'react';
import taskbar from 'chronos-assets/images/taskbar-icon.png';
import doubleChevron from 'chronos-assets/images/double-chevron-right.svg';

import {
  Container,
  Inner,
  TaskbarIcon,
  DoubleArrow,
} from './styled';


type Props = {
  /**
   * Function that is called after click
   * */
  onClick?: { (): void },
  /**
   * Set position of the button(true = 'static', false='absolute').
   * */
  isAbsolute: boolean,
  visible: boolean,
};
/**
 * Sidebar footer component
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](https://github.com/rahmonzoda)
 */
const SidebarShowButton = ({
  onClick,
  isAbsolute,
  visible,
}: Props) => (
  <Container
    onClick={onClick}
    position={isAbsolute}
    visible={visible}
  >
    <Inner>
      <TaskbarIcon src={taskbar} />
      <span>Show task bar</span>
      <DoubleArrow src={doubleChevron} />
    </Inner>
  </Container>
);

SidebarShowButton.defaultProps = {
  onClick: () => {},
  isAbsolute: true,
};

export default SidebarShowButton;
